import React from "react";
import { useAppSelector } from "@/redux/store";
import { useIsLoggedIn } from "@/hooks";

import UserProfileCompletionBlock from "./UserProfileCompletionBlock";

const UserProfileCompletionWrapper = ({ bannerData }) => {
  const styles = bannerData?.styles;
  const isLoggedIn = useIsLoggedIn();

  const profileCompletionPercentage = useAppSelector(
    state => state?.authReducer?.profileCompletionPercentage
  );
  const isUserProfileLoaded = typeof profileCompletionPercentage === "number";
  const isFullCompleted =
    isUserProfileLoaded && profileCompletionPercentage === 100;

  if (!isLoggedIn) return null;
  if (!isUserProfileLoaded) return null;
  if (isFullCompleted) return null;

  return (
    <div style={stylesForRow(styles, bannerData?.width)}>
      <UserProfileCompletionBlock />
    </div>
  );
};

const stylesForRow = (styles, width) => ({
  background: "linear-gradient(90deg, #8758FE 0%, #FF4291 50%, #FED86A 100%)",
  ...styles,
  maxWidth: width?.value,
  marginLeft: "auto",
  marginRight: "auto"
});

export default UserProfileCompletionWrapper;
